import styled from 'styled-components'

import {
  backgroundTypes,
  borderTypes,
  boxModelTypes,
  cssTypes,
  flexboxTypes,
  textTypes,
} from '../types'
import { background, border, boxModel, css, flexbox, text } from '../util'

/**
 * @namespace Footer
 * @desc Primitive styled-component 💅
 * @return {Function} React component
 */
const Footer = styled.footer`
  ${background};
  ${border};
  ${boxModel};
  ${css};
  ${flexbox};
  ${text};
`

/**
 * @name defaultProps
 * @memberof Footer
 * @desc Primitive's default properties
 */
Footer.defaultProps = {
  borderWidth: [0],
  flex: 'none',
  fontSize: 'baseFontSize',
  margin: [0],
  padding: [0],
  size: ['auto'],
}

/**
 * @name propTypes
 * @memberof Footer
 * @desc Primitive's prop type definitions
 */
Footer.propTypes = {
  ...backgroundTypes,
  ...borderTypes,
  ...boxModelTypes,
  ...cssTypes,
  ...flexboxTypes,
  ...textTypes,
}

/** @component */
export default Footer
